import { Skeleton } from '../../Skeleton'

import * as styles from './PageActions.module.css'

function PageActions({
  children,
  className = styles.PageActions,
  isLoading,
  ref,
}) {
  return (
    <div className={className} ref={ref}>
      {isLoading ? <Skeleton className={styles.skeleton} /> : children}
    </div>
  )
}

export default PageActions
